

import fms from '../folder/images/businesses/fms.png'
import hr from '../folder/images/businesses/hr.png'
import project from '../folder/images/businesses/project.png'
import transaction from '../folder/images/businesses/transaction.png'

import youtube from '../folder/images/fide.png'
import DOMPurify from "dompurify";

import {GoPlay} from 'react-icons/go';
import { IoCloseCircleOutline } from "react-icons/io5";

import transaction_bg from '../folder/images/vertical/real-estate.avif'
import project_bg from '../folder/images/vertical/project.jpg'
import hr_labs_bg from '../folder/images/vertical/hr-services.avif'
import fms_bg from '../folder/images/vertical/facility.avif'

import fms_logo from '../folder/images/logo/fms_logo.png'
import hr_logo from '../folder/images/logo/hr_labs_logo1.svg'
import transaction_logo from '../folder/images/logo/transaction_logo.png'
import projects_logo from '../folder/images/logo/projects_logo.svg'


import clientsImg from '../folder/images/clients_logo.jpg'
// import corp_image from '../folder/images/corp_main.jpeg'
import corp_image from '../folder/images/home_right.jpg'
import { blogsArr, email, fms_website_url, hrlabs_website_url, mobile, project_website_url, transaction_website_url, valuesArr } from '../folder/constants/Appconstants'
import { useNavigate } from 'react-router-dom'

import { Link } from 'react-router-dom'
import { Modal } from 'antd'
import { useState,useEffect,useRef } from 'react'

import ReactPlayer from 'react-player'

// overview section 
import clients_served from '../folder/images/overview/clients_served.png'
import inhouse_employees from '../folder/images/overview/inhose_employees.png'
import years_in_industry from '../folder/images/overview/years_in_industry.png'
import total_projects from '../folder/images/overview/total_projects.png'

import shilpa_foundation_banner from '../folder/images/ShilpaFoundation.jpeg'
import gallery_banner from '../folder/images/Gallery-image.jpg'

import achuth_gowda from '../folder/images/Achuth-Gowda.jpeg'

import CountUp from 'react-countup';
import { MdKeyboardArrowRight } from "react-icons/md";
// import FideLogo from '../../public/fide.mp4';
import { RiNewspaperLine } from "react-icons/ri";

// import videoplay from '../folder/images/Fidelitus.mp4'
import videoplay from '../folder/images/hub.mp4'
import toast from 'react-hot-toast'
import { GetBlogServices } from '../folder/services/BlogServices'
import { RiDoubleQuotesL,RiDoubleQuotesR } from "react-icons/ri";

export default function Home() {

  const videoRef = useRef(null);

  const navigator = useNavigate() 
  const [modal,setmodal] = useState(false) 

  const [datas,setdatas] = useState({})

  useEffect(()=>{
    getData()
  },[])

  useEffect(() => {
    const video = videoRef.current;
    if (video) {
      // Attempt to play the video
      video.play().catch(error => {
       toast.error("Oops we couldn't play the video for you!")

        // Handle error (e.g., show a play button)
        console.log('Autoplay prevented. Showing play button.');
      });
    }
  },[]);

  async function getData(){
    const response = await GetBlogServices(1,'')
    setdatas(response?.data)
  }

  const section_data = [
    {
     img:clients_served,
     heading:'Clients Served',
     count:6000
    },
    {
     img:inhouse_employees,
     heading:'In-House Employee',
     count:700
    },
    {
     img:years_in_industry,
     heading:'Years In Industry',
     count:11
    },
    {
     img:total_projects,
     heading:'Overall Projects',
     count:500
    }

  ]

  async function openDetail(v){
    navigator(`/blogs/detail/${v?._id}`)
  }

  const data = [
    {
     // img:transaction,
     imgage:transaction_bg,
     logo:transaction_logo,
     height:'50px',
     heading:'Fidelitus Transactions',
     ref:transaction_website_url,
     description:'<b>Fidelitus Transactions</b> We help you purchase, build, occupy and invest in an assortment of assets including industrial, commercial, retail and residential real estate. '
    },
    {
     // img:project,
     imgage:project_bg,
     logo:projects_logo,
     height:'50px',
     heading:'Fidelitus Projects',
     ref:project_website_url,
     description:'<b>Fidelitus Projects</b> is a leading Design-Build Commercial and industrial infrastructure provider based in Bengaluru.'
    },
    {
     // img:fms,
     imgage:fms_bg,
     logo:fms_logo,
     height:'50px',
     heading:'Fidelitus Facility Managment',
     ref:fms_website_url,
     description:'<b>Fidelitus Facility Managment</b> We take full responsibility to ensure the proper functionality, comfort, and safety of your space by integrating people'
    },
    {
     // img:hr,
     imgage:hr_labs_bg,
     logo:hr_logo,
     height:'50px',
     heading:'Fidelitus HR Labs',
     ref:hrlabs_website_url,
     description:'<b>Fidelitus HR Labs</b> is an end-to-end HR solutions provider that helps businesses find and hire the best talent faster. Beyond traditional HR services, we offer a comprehensive suite of solutions.'
    //  description:'<b>Fidelitus HR Labs</b> is a end-to-end HR Solutions that helps your businesses  find and hire  the best people faster, rather than hr services we provide many more'
    }
  ]


  return (
    <div className='bg-no-repeat  bg-continent-bg bg-cover '>

      <video ref={videoRef} autoPlay loop muted playsInline className="w-full h-auto md:h-[90vh] lg:h-[90vh]  object-cover">
        <source src={videoplay}  type="video/mp4"/> 
      </video>

      <Modal width={'50%'} footer={false} open={modal} closable={false}>
        <div className='w-[100%] relative'>
          <IoCloseCircleOutline onClick={()=>setmodal(!modal)} size={30} className='absolute text-white -top-5 -right-5 ' />
          <ReactPlayer width={'100%'} url='https://www.youtube.com/watch?v=xjUUzwsWwoI' />
        </div>
      </Modal>
        
        <div className='w-[90vw] md:w-[80vw] md:flex justify-between mx-auto my-20'>
            <div className='mb-10 md:w-[50%] md:mr-10 md:mb-0'>
             <h6 data-aos="fade-left" className='font_normal text-[19px] 2xl:text-[22px] flex'> <span className='min-w-[4px] block min-h-[4px] max-h-[21px] rounded mt-[2.5px] mr-4 bg-[#027d9b]'></span><strong style={{fontWeight:'800'}}>About Fidelitus</strong></h6>
             <h6 data-aos="fade-up" className='font_normal font-[400] my-4 text-[14px] 2xl:text-[17px] ml-5'>Fidelitus Corp is known to provide a full range of end-to-end property services. From identifying the right <b className='font_bold'>commercial/residential space</b> to devising with the expediency of place by concepts and design, the expediency of <b className='font_bold'>facility with cost</b>, beautifying with <b className='font_bold'>paintings</b> , and identifying the <b className='font_bold'>right human resource,</b> we take complete responsibility so that our patrons remain successful in their business by opting best choice.</h6>
             <h6 data-aos="fade-up" className='font_normal font-[400] my-4 text-[14px] 2xl:text-[17px] ml-5'>Our integrated platform provides patrons with market knowledge and insights and advises them in making the right decisions to support their growth. We come with our proven track record of having built a highly experienced cross-functional team comprising of various experts in our respective verticals. We are committed to accommodating an end-to-end service to our patrons which allows them to focus on their core businesses.</h6>
            
            </div>
            <div data-aos="fade-right" className='mt-5 md:mt-0 md:ml-10 md:w-[50%] relative group'>
               <img alt='img'  src={corp_image} />
              
            </div>
        </div>

      

      {/* vission & mission   */} 
      <div className='w-[100%] bg-gray-50 bg-continent-bg bg-no-repeat bg-cover border-t border-slate-100 px-[5%] md:px-[10%] md:flex  mx-auto '>
         <div data-aos="fade-right" className='md:w-[50%] border-b md:border-b-0 md:border-r border-slate-200  py-10'>
             <h6 className='font_bold flex text-[19px] 2xl:text-[22px]'><span className='min-w-[4px] block min-h-[4px] max-h-[21px] rounded mt-[2.5px] mr-4 bg-[#027d9b]'></span>  Our Vision</h6>
             <h6 className='text-[14px] 2xl:text-[17px] font_normal mt-4'>To be the preferred global partner in integrated service solutions, pioneering excellence in human resources, real estate transactions, interior architecture, and facility management. We envision a future where seamless collaboration and sustainable practices empower individuals and organizations to thrive in dynamic environments, fostering innovation and holistic growth.</h6>
         </div>
         <div data-aos="fade-left" className='md:w-[50%] md:pl-10  py-10'>
             <h6 className='font_bold flex text-[19px] 2xl:text-[22px]'><span className='min-w-[4px] block min-h-[4px] max-h-[21px] rounded mt-[2.5px] mr-4 bg-[#027d9b]'></span>  Our Mission</h6>
             <h6 className='text-[14px] 2xl:text-[17px] font_normal mt-4'>Our mission is to deliver exceptional service through integrated solutions in human resources, real estate transactions, interior architecture, and facility management. We aim to exceed client expectations with innovative, sustainable, and efficient services that enhance productivity and well-being. Guided by integrity and professionalism, we create lasting value for clients, employees, and communities.</h6>
         </div>
      </div>
       
      {/* services */}
      <div className='w-[90vw] md:w-[80vw] mx-auto my-20'>
        <h1 data-aos="fade-right" className='font_normal relative text-[20px] 2xl:text-[23px] text-center ' >Services We offer</h1>
        <div data-aos="fade-left" className='flex items-center justify-center mt-2'>
        <h1 className='font_normal  relative min-w-[100px] max-w-[100px] min-h-[3px] max-h-[3px] bg-[#027d9b]' ></h1>
        </div> 
        {/* <h1 data-aos="fade-up" className='font_normal relative text-[14px] 2xl:text-[17px] mt-2 text-center ' >The services that we provide are 100 % expertise providing to our customers where they meet there requirments!.</h1> */}
        <h1 data-aos="fade-up" className='font_normal relative text-[14px] 2xl:text-[17px] mt-2 text-center ' >We deliver services with complete expertise, ensuring our customers' requirements are met with precision and quality</h1>
        <div className='md:w-[100%] mx-auto grid grid-cols-1 gap-2  md:grid-cols-4 md:gap-5 mt-10'>
          {data?.map((d,i)=>(
            <a data-aos="fade-up" target='_blank' href={d?.ref}>
            <div key={i} className='cursor-pointer md:mb-5 group transition-all duration-300 flex flex-col items-center justify-center'>
              <div className='w-[100%] h-[240px] relative bg-slate-100  group overflow-hidden '>
                <img src={d?.logo} className={`group-hover:scale-110 duration-300 ${i==0 && 'w-[40%]  h-[55px] md:w-[57%] md:mt-6'}  ${i==1 && 'h-[35px] w-[80%]  md:w-[43%] md:h-[35px] mt-[30px] md:mt-[35px]'} ${i==2 && 'md:w-[50%] h-[38px] mt-[35px]'} ${i==3 && 'w-[100%] h-[40px] md:h-[35px] mt-[35px]'}  flex items-center justify-center mx-auto my-5  mix-blend-multiply`} />
                <h6 dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(d?.description)}} className='text-[12px] 2xl:text-[15px] text-center absolute top-[40%] font_normal font-[500] px-3 md:p-4'></h6>
              </div>
            </div>
            </a>
          ))}


        </div>


        
      </div>

      {/* core values   */}
      <div className='bg-gray-50 py-10'>
            <div className='w-[90vw] md:w-[80vw] mx-auto'>
              <h6  data-aos="fade-right"  className='font_bold text-[19px] 2xl:text-[22px] flex'> <span className='min-w-[4px] block min-h-[4px] max-h-[21px] rounded mt-[2.5px] mr-4 bg-[#027d9b]'></span> Our Core Values</h6>
              <h6  data-aos="fade-left"  className='font_normal text-[13px] 2xl:text-[16px] ml-5'>We are success because we believe and drive below mentioned values for our greater future .</h6>
            </div>  
            
            <div className='w-[80%] mx-auto my-10 grid grid-cols-2 md:grid-cols-6'>
              {valuesArr?.map((v,i)=>(
                <div  data-aos="fade-up"  className={`flex   ${i !== 5 && 'md:border-r border-slate-200'} flex-col items-center mb-4 justify-center`}>
                  <img className='w-[70px] h-[70px] object-contain' src={v?.icon} />
                  <h6 className='font_normal w-[85%] mx-auto text-center text-[13px] 2xl:text-[16px] mt-2 font-[800]'>{v?.value}</h6>
                </div>  
              ))}
            </div>
      </div> 

      {/* our overview */}
      <div className='bg-continent-bg bg-cover py-10'>
      <div className='w-[90vw] md:w-[80vw] mx-auto'>
        <h6 data-aos="fade-right" className='font_bold text-[19px] 2xl:text-[22px] flex'> <span className='min-w-[4px] block min-h-[4px] max-h-[21px] rounded mt-[2.5px] mr-4 bg-[#027d9b]'></span> Our Overview</h6>
        <h6 data-aos="fade-left" className='font_normal text-[14px] 2xl:text-[17px] ml-5'>We are success because we believe and drive below mentioned values for our greater future .</h6>
      </div>  
      <div className='md:w-[80%] md:h-[150px] mx-auto grid grid-cols-2  md:grid-cols-4 md:gap-5 mt-10'>
          {section_data?.map((d,i)=>(
            <div data-aos="fade-up" key={i} className='cursor-pointer group transition-all duration-300 flex flex-col p-5 items-center justify-center hover:bg-white hover:shadow-lg'>
                <img alt={'img'} src={d?.img} className='w-[60px] object-contain opacity-70 transition-all duration-300  group-hover:scale-75' />
                <h6 className='text-[15px] 2xl:text-[18px] text-center font_normal mt-2'>{d?.heading}</h6>
                <h6 className='text-[18px] 2xl:text-[21px] text-center font_normal font-[900] mt-0'><CountUp end={d?.count}/> +</h6>
            </div>  
          ))}
        </div>
      </div>  
      
      {/* our function */}
      <div className='bg-gray-50 md:min-h-[420px] md:max-h-[400px] md:flex border-t border-slate-100 justify-between px-[5%] md:px-[10%] mx-auto py-10 '>

        <div  className='flex bg-white md:min-w-[42%] md:max-w-[42%]'>

        <div className='p-0'>
          <iframe className='w-[125%] h-[338px] md:w-[161.5%] md:h-[339px]' src="https://www.youtube.com/embed/xjUUzwsWwoI?si=Hh2qRIB2qV4pKbED" loop title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </div>

      
        </div>


        <div data-aos="fade-left" className='mt-10 md:mt-0  md:flex md:w-[50%]'>

          <div className='bg-[#78afc1] relative p-4 md:w-[50%] z-20'>
          <div className='w-[20px] h-[35px] absolute bg-[#78afc1] bottom-[-10px] right-[10px] rotate-[45deg] md:top-[10px] md:-right-[5px] md:rotate-[40deg]'></div>

              <h6 className='font_bold 2xl:text-[21px]'> Managing Director - Message</h6>


              {/* <h6 className='text-[13px] 2xl:text-[16px] my-5 font_normal' >A Founder is the first employee of the organization and when they treat even employee as an EMPLOYER those individuals develop a sense of responsibility & belongingness towards the company and the success derived out of such efforts transcends to a whole new level!</h6> */}
              <h6 className='text-[13px] 2xl:text-[16px] my-5 font_normal' >A Founder is the first employee of any organization. When they treat every team member as an integral part of the mission — almost like a co-owner — it fosters a deep sense of responsibility and belonging. The success that emerges from this shared ownership is not only meaningful, but also transformative</h6>

              <h6 className='font_bold text-[15px] 2xl:text-[18px] font-[700]'>Achuth Gowda</h6>
              <h6 className='text-[10px] 2xl:text-[13px] font_normal'>Founder and Managing Director</h6>
          </div>

          <div className='md:w-[50%] h-[100%]'>
              <img src={achuth_gowda} className='w-[100%] object-cover h-[100%]' />  
          </div>
        </div>

      </div>

       {/* our wings  */}
       <div className=' w-[90vw] pt-10 md:w-[80vw] mx-auto'>
          <h1 data-aos="fade-left" className='font_bold relative text-[20px] 2xl:text-[23px] text-center ' >Our Wings</h1>
            <div data-aos="fade-right" className='flex items-center justify-center mt-2'>
            <h1 className='font_normal  relative min-w-[100px] max-w-[100px] min-h-[3px] max-h-[3px] bg-[#027d9b]' ></h1>
            </div> 
       </div>

       {/* <h1 data-aos="fade-up" className='font_normal w-[90%] mx-auto relative text-[14px] 2xl:text-[17px] mt-2 text-center pb-10' >The other co services we spread our wings to bring a social welfare impact!.</h1> */}
       <h1 data-aos="fade-up" className='font_normal w-[90%] mx-auto relative text-[14px] 2xl:text-[17px] mt-2 text-center pb-10'>Through our other various wings, we extend our efforts to drive meaningful social impact and contribute to the greater good</h1>
       <div className='pb-10 md:flex items-center justify-between w-[90%] md:w-[80%] mx-auto'>
          
         <div data-aos="fade-right" className='md:min-w-[60%] md:max-w-[60%]'>
         <div className='mb-10 border-l-4 border-l-[#027d9b]/50 pl-6'>
          <h6 className='font_bold text-[20px] 2xl:text-[23px] font-[700]'>Shilpa Foundation </h6> 
          <h6 className='font_normal my-4 text-[14px] 2xl:text-[17px] w-[92%]'>The foundation’s vision is a tri-dimensional approach, for the total upliftment of the Government Schools in the Rural Areas of the Karnataka State, wherein the ENVIRONMENT, HEALTHCARE, and EDUCATION has to be streamlined to lift it up to a decent standard. </h6>   
         </div>

         <div className='-mt-5 ml-5'>
           <h6 onClick={()=>navigator('/shilpa_foundation')} className='bg-[#027d9b]/50 text-black cursor-pointer font_normal text-[14px] w-max px-2 py-1'>View More</h6>
         </div>
          <div className='md:flex mt-8'>
            <div className='md:w-[45%] h-[240px] overflow-hidden object-cover'>
               <img className='w-[100%] h-[100%] duration-300 transition-all hover:scale-105' src={shilpa_foundation_banner} />
            </div>
            <div className='md:pl-5 md:w-[45%] bg-gray-50 px-5 mx:px-0 z-10 pb-4 md:pb-0 relative'>
              <div className='w-[20px] h-[35px] absolute bg-gray-50 -top-[10px] md:top-2 -z-10 right-[15%] rotate-[40deg] md:left-[-4px] -rotate-[45deg]'></div>
               <h6 className='font_normal text-[16px] 2xl:text-[19px] pt-5  md:pt-0 md:mt-5 font-[800]'>Support to children and age people by Shilpa Foundation</h6>
               <h6 className='text-[14px] 2xl:text-[17px] font_normal my-4 w-[90%]'>Helping more than 500 + people every month to reach their vision in the upcoming future by Fidelitus Corp </h6>

               <div onClick={()=>navigator('/shilpa_foundation')} className='flex items-center cursor-pointer '>
                <h6 className='font_normal text-[13px] 2xl:text-[16px] hover:underline text-[#027d9b]'>Read More</h6>
                <MdKeyboardArrowRight className='text-[#027d9b] mt-1' />
               </div>
            </div>
          </div>
         </div> 

         <div data-aos="fade-left" className='md:min-w-[40%] mt-10 md:mt-0 md:max-w-[28%]'>
         <div className='mt-5'>
            <div className='w-[100%] h-[250px] overflow-hidden object-cover'>
               <img className='w-[100%] h-[100%] duration-300 transition-all hover:scale-105' src={gallery_banner} />
            </div>
            <div className=' w-[100%] bg-gray-100 z-10 pt-2 px-4 pb-1 relative'>
              <div className='w-[20px] h-[35px] absolute bg-gray-100 -top-[10px] -z-10 right-[15%] rotate-[40deg]'></div>
               <h6 className='font_normal text-[16px] 2xl:text-[19px] pt-2 font-[800]'>Fidelitus Gallery is a contemporary new generation art gallery where the paintings are displayed and sold. </h6>
               <h6 className='text-[14px] 2xl:text-[17px] font_normal my-2 w-[90%]'> It promotes various art forms and showcases impactful paintings. </h6>
               <div onClick={()=>navigator('/shilpa_foundation')} className='flex items-center cursor-pointer '>
                <h6 className='font_normal text-[13px] 2xl:text-[16px] hover:underline my-1 text-[#027d9b]'>Read More</h6>
                <MdKeyboardArrowRight className='text-[#027d9b] -mt-0' />
               </div>
            </div>
           </div> 
         </div>
       </div>

        {/* testimonials  */}
        <div className='bg-white py-10'>
       <div className='w-[90vw] md:w-[80vw] mx-auto'>
          <h6 data-aos="fade-up" className='font_bold text-[19px] 2xl:text-[22px] flex'> <span className='min-w-[4px] block min-h-[4px] max-h-[21px] rounded mt-[2.5px] mr-4 bg-[#027d9b]'></span>Clients We Served</h6>
          <h6 data-aos="fade-up" className='font_normal text-[13px] 2xl:text-[16px] ml-5'>Client Who are Empowered by Trust, Driven by Excellence .</h6>
          </div>  
          <div className='w-[90%] md:flex items-center  md:w-[80%] mx-auto my-5'>

             <div data-aos="fade-right" className='md:w-[50%]'>
                  <img src={clientsImg} />
             </div>

             <div className='mt-14 relative md:mt-0 md:w-[48%] md:ml-[2%]'>
              <RiDoubleQuotesL className='absolute -mt-12 text-[#333d47]/10' size={45} />  
              <h6 data-aos="fade-up"  className='text-[14px] 2xl:text-[17px] font_normal '>We are deeply grateful to our clients, whose trust and support have been instrumental in shaping who we are today. Your belief in us has allowed us to grow, innovate, and succeed. Thank you for giving us the chance to prove ourselves and make a positive impact together.</h6>
              
              <h6 data-aos="fade-up" className='text-[14px] 2xl:text-[17px] font_normal mt-5'> we are proud to have served over <span className='font_bold'>6,000 + </span> clients, delivering excellence and dedication in every project. Your trust in us drives our commitment to quality and innovation, shaping our journey to success together.</h6>
            
              <RiDoubleQuotesR className='absolute right-0 -mb-12 text-[#333d47]/10' size={45} />  
            
             </div>  
          </div>  
        </div>


        {/* blogs  */}
        <div className='bg-gray-50 py-10'>
          <div className='w-[90vw] md:w-[80vw] mx-auto'>
          <h6 data-aos="fade-up" className='font_bold text-[19px] 2xl:text-[22px] flex'> <span className='min-w-[4px] block min-h-[4px] max-h-[21px] rounded mt-[2.5px] mr-4 bg-[#027d9b]'></span> Featured Stories</h6>
          <h6 data-aos="fade-up" className='font_normal text-[13px] 2xl:text-[16px] ml-5'>We believe that true impact comes from defining changes that empower communities, propel growth and infuse goodness.</h6>
          </div>  


          <div className='w-[90%] md:w-[80%] mx-auto my-5'>
            <div className='grid md:grid-cols-3 md:gap-5'>
                {datas?.datas?.slice(0,3)?.map((b,i)=>(
                  <div data-aos="fade-up" onClick={()=>openDetail(b)} className={`w-[100%]  mb-4 md:mb-0 relative cursor-pointer`}>
                    <div className='h-[250px] overflow-hidden group '>
                       <img src={`${process.env.REACT_APP_AWS_IMAGE_URL}${b?.blog_image}`} className={'h-[250px] w-[100%] duration-300 transition-all group-hover:scale-110'} />
                    </div>
                    <div className='mt-1 p-4'>
                    <h6  className='font_normal line-clamp-3 font-[700] text-[#000]/80 text-[14px] 2xl:text-[17px] break-word'>{b?.title}</h6>
                    <h6  className='font_normal mt-2 line-clamp-3 font-[400] text-[#000]/80 text-[12px] 2xl:text-[15px] break-word'>{b?.motive}</h6>
                    <h6 className='font_normal mt-2 text-[11px] 2xl:text-[14px] font-[700] text-[#027d9b]'>{(b?.tags !== undefined && b?.tags?.length > 0) && b?.tags[0]?.name}</h6>
                    </div>
                </div>  
                ))}
            </div>

          </div>
          
        </div>

        {/* contact  */}
        <div className='bg-[#333d47] md:flex items-center justify-between  p-10 px-[10%]'>

          <div>
             <h6 className='text-[22px] 2xl:text-[25px] font_bold text-white'>We're here to help</h6>
             <h6 className='text-[14px] 2xl:text-[17px] font_normal text-white/60'>Contact our team who will be always ready to assist your query!</h6>
          </div>


          <div className='mt-4 md:mt-0 flex items-center'>
            <Link to={`tel:${mobile}`} target='_blank'>
             <h6 className='cursor-pointer bg-[#537898] border border-[#537898]  mr-4 text-white px-5 w-max py-2.5 text-[14px] 2xl:text-[17px] font_normal'>Contact us</h6>
            </Link>
            <Link to={`tel:${email}`} target='_blank'>
             <h6 className='border cursor-pointer border-[#537898] text-white px-5 w-max py-2.5 text-[14px] 2xl:text-[17px] font_normal'>E-Mail us</h6>
            </Link>
          </div>

        </div>

       
    </div>
  )
}
